import React from "react";
import { Checkbox, ICheckboxProps } from "common/checkbox";
import { useField } from "formik";

interface IFormikCheckboxFieldProps extends Omit<ICheckboxProps, "checked"> {
  label: React.ReactNode;
  name: string;
  labelId?: string;
}
export const FormikCheckboxField: React.FC<IFormikCheckboxFieldProps> = ({
  label,
  name,
  labelId,
  ...props
}) => {
  const [field, , helpers] = useField<boolean>({ name });
  return (
    <Checkbox
      label={label}
      checked={field.value}
      onChange={(e) => helpers.setValue(e.target.checked)}
      aria-labelledby={labelId}
      {...props}
    />
  );
};
